var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 18.5H5.75C2.1 18.5 0 16.4 0 12.75V5.75C0 2.1 2.1 0 5.75 0H15.75C19.4 0 21.5 2.1 21.5 5.75V12.75C21.5 16.4 19.4 18.5 15.75 18.5ZM5.75 1.5C2.89 1.5 1.5 2.89 1.5 5.75V12.75C1.5 15.61 2.89 17 5.75 17H15.75C18.61 17 20 15.61 20 12.75V5.75C20 2.89 18.61 1.5 15.75 1.5H5.75Z",
    fill: "#F68B1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7498 10.12C9.90978 10.12 9.05978 9.85997 8.40978 9.32997L5.27978 6.82997C4.95978 6.56997 4.89978 6.09997 5.15978 5.77997C5.41978 5.45997 5.88978 5.39997 6.20978 5.65997L9.33977 8.15997C10.0998 8.76997 11.3898 8.76997 12.1498 8.15997L15.2798 5.65997C15.5998 5.39997 16.0798 5.44997 16.3298 5.77997C16.5898 6.09997 16.5398 6.57997 16.2098 6.82997L13.0798 9.32997C12.4398 9.85997 11.5898 10.12 10.7498 10.12Z",
    fill: "#F68B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.095337e5cae390c6046487045f0f69f9.svg";
export { ForwardRef as ReactComponent };